import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { TeamConfirmationComponent } from 'src/app/_components/remote-action-step/team-confirmation/team-confirmation.component';

@Injectable()
export class TeamConfirmationRemoteActionBuilderUiStep
  implements GenericRemoteActionBuilderUIStep {
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(this.constructor.name, '- getComponent called');
    return TeamConfirmationComponent;
  }

  public isVisible(currentData: any): boolean {
    // Always Visible
    return true;
  }
}
